var chunkToChildrenMap = {
	"5484": [
		3774
	],
	"7944": [
		8664
	],
	"8070": [
		3774
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));